<template>
  <div>
    <HomeSlider />
    <div class="container-fluid">
      <section id="about" class="row container-white block-about">
        <div class="container">
          <div class="row">
            <div class="col-md-7">
              <div class="title_holder">
                <h3 class="title">{{ $t("main_page.title") }}</h3>
                <div class="desc" v-html="getDesc"></div>
              </div>
              <!-- <div class="sign_holder">
                <img src="../assets/images/about-sign.png" alt>
                <h3 class="name">{{ $t("main_page.director") }}</h3>
                <p class="occ">{{ $t("main_page.d_position") }}</p>
              </div> -->
            </div>
            <div class="col-md-5">
              <p class="text-center as-mini-title">
                <span>{{ $t("main_page.qualitatively") }}</span>
              </p>
              <parallax-container class="as-paralax">
                <parallax-element
                  class="paralax-block"
                  :parallaxStrength="-30"
                  :type="'translation'"
                ></parallax-element>
                <parallax-element
                  class="paralax-image"
                  :parallaxStrength="-60"
                  :type="'translation'"
                ></parallax-element>
              </parallax-container>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="container-fluid container-dark">
      <HomeCarousel />
    </section>
    <section id="thanksLetters" class="container-fluid comment-users">
      <div class="background-overlay"></div>
      <div class="container">
        <ThanksLetters />
      </div>
      <div class="clearfix"></div>
    </section>
    <Footer />
  </div>
</template>

<script>
import HomeCarousel from "@/components/HomeCarousel.vue";
import HomeSlider from "@/components/HomeSlider.vue";
import ThanksLetters from "@/components/ThanksLetters.vue";
export default {
  computed: {
    getDesc() {
      return this.$i18n.messages[this.$i18n.locale].main_page.description;
    },
  },
  data() {
    return {};
  },
  components: {
    HomeCarousel,
    HomeSlider,
    ThanksLetters,
  },
};
</script>
<style>
#thanksLetters {
  padding: 45px 0;
}
.as-mini-title {
  font-style: italic;
  font-weight: 600;
}
.as-mini-title span {
  border-bottom: 3px solid #d24e1a;
  line-height: 48px;
  padding-bottom: 5px;
  font-size: 24px;
}
.container {
  position: relative;
}
.block-another {
  background-color: #f8feff;
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 150px 0px 150px 0px;
  position: relative;
}
.block-another .background-overlay {
  background-image: url("../assets/images/abstract.png");
  background-position: top right;
  background-repeat: no-repeat;
  opacity: 0.1;
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background-color: transparent;
}
.r_inner {
  width: 100%;
  float: left;
  clear: both;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
}
.block-about {
  padding: 150px 0px 150px 0px;
}
.block-about .title_holder {
  padding-top: 0;
}
.block-about .title_holder:after,
.block-about .title_holder:before {
  content: none;
}
.block-news .item {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
}
.block-news .item .title_holder a:hover {
  color: #45a2df;
}
.block-news .img_holder {
  border-radius: 5px;
  overflow: hidden;
}
.block-news .time {
  border-top-left-radius: 5px;
  overflow: hidden;
  position: absolute;
  z-index: 15;
  padding: 20px 19px 25px 19px;
  max-width: 100%;
  width: 80px;
}
.block-news .time span:before {
  position: absolute;
  content: "";
  left: 0px;
  bottom: 0px;
  border-top: 15px solid #ad3110;
  border-right: 80px solid transparent;
  z-index: -1;
}
.block-news .time span:after {
  position: absolute;
  content: "";
  top: 0px;
  left: 0px;
  bottom: 15px;
  right: 0px;
  background-color: #ad3110;
  z-index: -1;
}
.block-news .time h3 {
  margin: 0px;
  padding: 0px;
  color: #fff;
  font-size: 36px;
  line-height: 1;
  letter-spacing: -2px;
  position: relative;
  margin-bottom: 5px;
  font-weight: 300;
}
.block-news .time h3:after {
  left: 0px;
  right: 0px;
  position: absolute;
  content: "";
  background-color: #ffc600;
  height: 1px;
  top: 100%;
}
.block-news .time h5 {
  margin: 0px;
  padding: 0px;
  color: #fff;
  letter-spacing: 0px;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  text-transform: uppercase;
}
.block-news .img_holder {
  position: relative;
}
.block-news .img_holder a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
.block-news .img_holder img {
  position: relative;
  min-width: 100%;
  max-width: 100%;
  border: none;
  height: 262px;
  object-fit: cover;
}
.block-news .title_holder:first-child {
  margin: 0px 0px 50px 0px;
}
.block-news .title_holder:first-child h3 {
  margin: 0px;
  padding: 0px;
  font-size: 60px;
  line-height: 1;
  letter-spacing: 0px;
  color: #14141c;
  font-weight: 300;
  padding-bottom: 23px;
  position: relative;
  left: -3px;
}
.block-news .title_holder:first-child h3:after {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 3px;
  width: 100px;
  height: 3px;
  background-color: #d24e1a;
  border-radius: 10px;
}
.block-news .item .title_holder {
  width: 100%;
  float: left;
  clear: both;
  padding: 24px 0px 0px 0px;
}
.block-news .item .title_holder > h3 {
  margin: 0px;
  padding: 0px;
  font-size: 24px;
  letter-spacing: 0px;
  color: #041230;
  line-height: 1.2;
  margin-bottom: 24px;
}
.block-news .item .title_holder > h3 a {
  color: #041230;
  text-decoration: none;
}
.block-news p.t_footer a.bg {
  display: inline-block;
  border-radius: 3px;
  background-color: #081225;
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  line-height: 24px;
  padding: 8px 25px;
}
.comment-users {
  background-image: url("../assets/images/single-testimonial.jpg");
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 0 0px 50px 0px;
  position: relative;
}
.comment-users .inner {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  border: 10px solid rgba(238, 238, 238, 0.2);
  padding: 61px 150px;
  box-sizing: border-box;
}
.comment-users .inner svg,
.comment-users .inner img {
  position: absolute;
  width: 60px;
  height: 60px;
  top: 60px;
  left: 60px;
  color: #d24e1a;
}
.comment-users .inner * {
  color: #eee;
}
.comment-users .inner h5 {
  color: #d24e1a;
}
.background-overlay {
  background-color: #14151e;
  opacity: 0.9;
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
}
.top_section {
  width: 100%;
  float: left;
  clear: both;
  padding: 50px;
  background-color: #fff;
  padding-bottom: 52px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);
  position: relative;
}
.top_section .badge_holder {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  border: 10px solid #d24e1a;
}
.top_section .badge_left {
  width: 50%;
  float: left;
  position: relative;
  padding: 17px 20px 8px 20px;
}
.top_section .b_title {
  margin-bottom: 60px;
  width: 100%;
  float: left;
  clear: both;
}
.top_section .b_title h3 {
  margin: 0;
  padding: 0;
  font-size: 18px;
  letter-spacing: 0;
  color: #14141c;
}
.top_section .b_desc {
  width: 100%;
  float: left;
  clear: both;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.badge_left .year {
  font-size: 72px;
  line-height: 1;
  letter-spacing: -1px;
  color: #14141c;
  font-weight: 300;
  margin-right: 14px;
}
.badge_left .text {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #d24e1a;
}
.badge_right {
  left: 50%;
  right: 0px;
  top: 0px;
  bottom: 0px;
  position: absolute;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../assets/images/badge-img.jpg");
}
.rating_holder {
  position: absolute;
  right: 70px;
  top: 50px;
  width: 80px;
  padding: 6px 13px 11px 13px;
  text-align: center;
  background-color: #316397;
  color: #fff;
}
.rating_holder .r_header {
  position: absolute;
  left: 0px;
  right: 0px;
  height: 10px;
  background-color: #316397;
  bottom: 100%;
}
.rating_holder .r_header:before {
  border-top: 10px solid transparent;
  border-left: 5px solid #111623;
  content: "";
  position: absolute;
  left: 100%;
  top: 0px;
}
.rating_holder .r_header:after {
  border-top: 10px solid transparent;
  border-right: 5px solid #111623;
  content: "";
  position: absolute;
  right: 100%;
  top: 0px;
}
.rating_holder a {
  display: block;
  position: absolute;
  top: -10px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 22;
}
.rating_holder svg,
.rating_holder img {
  width: 36px;
  height: 36px;
  position: relative;
  margin-top: -11px;
  fill: currentcolor;
}
.rating_holder h3.rating_number {
  margin: 0px;
  padding: 0px;
  font-size: 24px;
  letter-spacing: -0.25px;
  font-weight: 500;
  color: #fff;
  position: relative;
  margin-top: -7px;
  margin-bottom: 5px;
}
.rating_holder h3.rating_text {
  margin: 0px;
  padding: 0px;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;
  letter-spacing: 0px;
  font-weight: 400;
  color: #fff;
}
.bottom_section {
  width: 100%;
  float: left;
  clear: both;
  padding: 50px;
  background-color: #fff;
}
.bottom_section ul {
  list-style-type: none;
  margin: 0px;
}
.bottom_section li {
  margin: 0px;
  margin-bottom: 20px;
  float: left;
  clear: both;
  width: 100%;
}
.bottom_section .item {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  padding-left: 50px;
  min-height: 30px;
  display: flex;
  align-items: center;
}
.bottom_section .icon {
  position: absolute;
  top: 0px;
  left: 0px;
  display: block;
  width: 30px;
  height: 30px;
  border: 2px solid #d24e1a;
  color: #d24e1a;
}
.bottom_section .icon svg,
.bottom_section .icon img {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -7px 0px 0px -7px;
}
.bottom_section p {
  margin: 0;
  padding: 0;
  font-size: 18px;
  color: #14141c;
}
section {
  padding: 30px 0;
}
.miniboxes {
  position: relative;
}
.container-dark {
  background: #0e141f;
  position: relative;
  padding: 0 15px;
}
.shape span.shape1 {
  position: absolute;
  left: 0px;
  bottom: 100%;
  border-right: 20px solid rgba(49, 99, 151, 0.4);
  border-top: 30px solid transparent;
}
.shape span.shape2 {
  position: absolute;
  left: 20px;
  bottom: 100%;
  border-left: 1150px solid rgba(49, 99, 151, 0.4);
  border-top: 30px solid transparent;
  border-left-width: 1140px;
}
.miniboxes {
  padding: 30px 0;
}
.miniboxes .item {
  width: 100%;
  float: left;
  clear: both;
  height: 100%;
  position: relative;
  border: 10px solid #eee;
  padding: 105px 50px 95px 50px;
  border-radius: 5px;
  color: #fff;
}
.miniboxes .item .number_holder {
  background-color: #d24e1a;
  color: #eee;
  border-bottom-left-radius: 5px;
  position: absolute;
  width: 70px;
  height: 80px;
  left: 50px;
  top: -10px;
  font-size: 36px;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.miniboxes .item .number_holder:after {
  border-top: 70px solid rgba(210, 78, 26, 0.4);
  content: "";
  position: absolute;
  left: 100%;
  top: 10px;
  border-right: 20px solid transparent;
  transition: all 0.3s ease;
}
.miniboxes .item:hover .number_holder:after {
  border-right-width: 30px;
}
.container-white {
  background: #fff;
}
.as-paralax {
  position: relative;
  width: 70%;
  height: 450px;
  margin: 0 auto;
}
.as-paralax .paralax-block {
  position: absolute;
  height: 100%;
  width: 100%;
  border: 12px solid #d24e1a;
}
.as-paralax .paralax-image {
  background: url("../assets/images/about-img.jpg") no-repeat;
  background-size: cover;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 5%;
  top: 5%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
}
h3.title {
  margin: 0px;
  padding: 0px;
  font-size: 60px;
  line-height: 1;
  letter-spacing: 0px;
  color: #041230;
  font-weight: 300;
  padding-bottom: 14px;
  position: relative;
  margin-bottom: 32px;
}
h3.title:after {
  content: "";
  position: absolute;
  bottom: -9px;
  left: 0px;
  width: 100px;
  height: 3px;
  background-color: #d24e1a;
}
.sign_holder img {
  margin-bottom: 26px;
}
h3.name {
  margin: 0;
  padding: 0;
  font-size: 18px;
  letter-spacing: 0px;
  font-weight: 400;
  color: #041230;
  margin-bottom: 2px;
}
p.occ {
  color: #666;
  margin: 0px;
  padding: 0px;
  letter-spacing: 0px;
  font-size: 14px;
}
</style>
